import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { PageType } from '@treams/treams-network';
import { Container, Jumbo, PAGE_CONTENT_WIDTH, tokens } from '@treams/treams-ui';

import GoalsTabs from '../GoalsTabs';
import CollectiveGoalsV2 from './CollectiveGoalsV2';
import { CollectiveGoalsList } from './Common';

export default function CollectiveGoals() {
	const { t } = useTranslation();
	const hasParentDepartmentGoals = useFeature(graphql.FeatureName.GoalsParentDepartmentGoals);

	if (hasParentDepartmentGoals) {
		return <CollectiveGoalsV2 />;
	}

	return (
		<>
			<Jumbo.Editable
				hasMediaUpload
				page={PageType.GoalsDepartment}
				title={t('goals.index.title')}
				description={t('goals.index.description')}
				footer={<GoalsTabs />}
			/>
			<Container mt={`${tokens.gap.page}px`} mb={4} wide={PAGE_CONTENT_WIDTH}>
				<CollectiveGoalsList />
			</Container>
		</>
	);
}
